<template>
	<div>
		<div>
			<div class="box">
				<span class="title">选择性别，开启智能推荐</span>
				<span class="title-tips">所填信息仅用于智能推荐</span>
				<div class="man-content" @click="goTabs(0)">
					<img src="../../../static/man.png" alt="">
					<div class="content-right">
						<span class="content-top">我是帅哥</span>
						<span class="content-text">战神赘婿，修仙玄幻</span>
					</div>
				</div>
				<div class="woman-content" @click="goTabs(1)">
					<img src="../../../static/woman.png" alt="">
					<div class="content-right">
						<span class="content-top">我是美女</span>
						<span class="content-text">霸道总裁，穿越重生</span>
					</div>
				</div>
				<span class="jump" @click="goTabs(2)"> 跳过>></span>
			</div>
		</div>
	</div>
</template>
<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		data() {
			return {
				pageType: '',
				boyBook: 0,
				girlBook: 0

			}
		},
		mounted() {
			this.girlBook = this.$route.query.girlBook;
			this.boyBook = this.$route.query.boyBook;
			this.pageType = this.$route.query.pageType;
			this.$commonApi.share();
		},
		methods: {
			goTabs(index) {
				var bookId = index == 1 ? this.girlBook : this.boyBook;
				if(index!=2){
					this.sendUserFrequency(index);
				}
				if (this.pageType == 'index') {
					this.$router.replace({
						path:'/pages/bookRead/index',
						bookid:bookId,
						pageType:'bookFrency'
					})
				} else {
					this.$router.go(-1)
				}
			},
			sendUserFrequency(index) {
				var params = {
					frequency: index
				}
				this.$api.sendUserFrequency(params).then(res => {
					if (res.status == 1) {
						 this.$base.setStorage('frequency', index)
					}
				})
			},
		}
	}
</script>

<style scoped>
	.box {
		flex-direction: column;
		align-items: center;
		align-content: center;
		width: 100%;
		padding: 0px 20px;
		box-sizing: border-box;
	}

	.box>div {}

	.title {
		margin-top: 98px;
		font-size: 20px;
		color: #111111;
		display: block;
		text-align: center;
	}

	.title-tips {
		margin-top: 12px;
		font-size: 16px;
		color: #aaaaaa;
		text-align: center;
		display: block;

	}

	.man-content,
	.woman-content {
		width: 100%;
		height: 120px;
		border-radius: 8px;
		display: flex;
	}

	.man-content {
		margin-top: 32px;
		background-color: #f2f8ff;
	}

	.man-content img {
		width: 112px;
		height: 104px;
		margin-top: 16px;
		margin-left: 24px;
		margin-right: 28px;
	}

	.woman-content {
		margin-top: 24px;
		background-color: #fff2f7;
	}

	.woman-content img {
		width: 98px;
		height: 108px;
		margin-top: 12px;
		margin-left:30px;
		margin-right: 36px;
	}

	.content-right {
		flex-direction: column;
	}

	.content-top {
		font-size: 16px;
		color: #111111;
		margin-top: 28px;
		display: block;
	}

	.content-text {
		font-size: 12px;
		color: #aaaaaa;
		margin-top: 8px;
		display: block;
	}

	.jump {
		position: fixed;
		right: 20px;
		bottom: 24px;
		font-size: 14px;
		color: #aaaaaa;
	}
</style>



// WEBPACK FOOTER //
// src/view/bookFrency/index.vue